import $ from 'jquery';

import values from 'lodash/values';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';
import isEqual from "lodash/isEqual";

import store from "./../../store";
import {
  fixDbFeatureProperties,
  getArrayOfIdsFromBvState,
  getSlabsFeatureGroup,
} from "../../misc/helpers";
import {baseDashboardImagesPath} from "../assets";
import DesignNavigationItem from "./designNavigationItem";
import ActionTypes from "../../misc/actionTypes";
import {isFeatureEnabled, isVisibleForNavigation} from "../../misc/displayLogic";
import * as types from "../../actions/actionTypes";
import {setActiveQuoteIndex, setQuotes} from "../../actions/roomsFunctions";
import {
  restoreCart,
  setCameFromPage,
  setQtCategoriesLoaded,
  // toggleUseFabricatorCostPrices
} from "../../actions/actionFunctions";
import {restoreContractValues} from "../../actions/contractsActions";
import {getBvFeatures} from "../../api/server-api";
import {dbFeatureRelatedFeaturesProperties, PartMenuType} from "./constants";
import {changeSqftFeaturesPopup} from "../../actions/sqftFunctions";
import {SQFT_FEATURES} from "../sqft/constants";
import {getLookId} from "../look/lookNavigation/lookFunctions2";
import {AVAILABLE_VISUALIZER_TYPES, IS_LIXIL_UI, IS_QKB_UI, USE_NEW_NAV} from "../../config";
// import {getBvGroupFeatures} from "../../api/server-api";
import {getCommonVisualizerType} from "../../config";
import {getCurrentLayout, getCurrentZIndexes} from "../appLayout";
import {LOOK_OVERLAYS, LOOK_ROOM_TYPES, ShowerHeadTypes} from "../look/core/constants";
import {getCurrentRoomType} from "../appLayout";
import Config from "../../config";
import {
  fixFeaturesResponse,
  getCartItemPartIdFix,
  getFeatureGroupsProperties, setFeatureGroupsProperties
} from "../../misc/backendFunctions";
import {
  getCartStateForLocalStorage,
  restoreCameFromPageFromLocalStorage,
  setLocalStorageState,
} from "../../misc/localStorageState";
import {
  getAvailableSteps,
  getCompressedAllWizardValues
} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {restoreAllWizardSelectedValues} from "../../actions/wizardFunctions";
import {replaceIncorrectSymbols} from "../../misc/misc2";
import {requestAfterRoomChange} from "../look/lookNavigation/lookNavigationFunctions";
import {updateCurrentQuote} from "../../misc/quotesFunctions";
import {
  getFeatureGroupFromWizardSteps,
  updateCartItemWizardValues
} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {updateExistingFeature} from "./featuresFunctions";
import {setReceiptSignature, setReceiptHomeDepotFields} from "../../actions/printFunctions";
import {getExportAIData} from "../ai/aiFunctions";
import {setLookAiImportData} from "../ai/aiActions";
import {hardCodeIsAmericanStandard} from "../../misc/fabricatorHardcode";

export default class LayoutCommon {
  initialized = false;
  selectedLayoutFeatures = {};
  disabledClickablePartIds = [];
  allDbFeatures = {}; // is used for creating fake layouts and checking loaded features. Object! // {"groupName": []}

  /**
   * An hash-table of parts, so we can find easily needed part by its ID
   * @type {Object.<string, Object>}
   */
  parts = {};
  constructor() {}

  hasNavItemsLength(...props) {
    const subPart = props[0];
    if ((document.kvConfig.visualizerType === "kvScene") && (this.type === 3) && (subPart.part.partId === "center_island_edge")) {
      return false
    }
    if (!subPart || !this.isNewLayout || (this.type === 2 && (subPart.part.partId === "oven"))
      || (subPart.part.partId === "shower_door")) { // not sure if we can enable it on old kitchen and bathroom
      // added oven because it depends on the stove and should be recalculated each time on layout 2
      // added shower door as we need to calculate for current showersize
      return this.designNavigationItems(...props).length > 0
    }
    const propName = IS_LIXIL_UI
      ? "all"
      : props[4] ? "qt" : "vis"; // forQuotingTool or forVisualizer
    if (IS_LIXIL_UI) {
      props[4] = "all"
    }
    if (!subPart.part._navItemsCount) {
      subPart.part._navItemsCount = {}
    }
    if (!subPart.part._navItemsCount[this.type]) {
      subPart.part._navItemsCount[this.type] = {}
    }
    if (subPart.part._navItemsCount[this.type][propName] > 0) {
      return true
    }
    if (document.kvConfig.visualizerType === "kvScene") {
      if ((this.type === 1) && (subPart.part.partId === "fridge_enclosure") && (propName === "vis")) {
        return false // we don't have any fridge enclosure for visualizer on the first room layout
      }
    }
    if (!subPart.part.allFeaturesReceived
      || !Number.isInteger(subPart.part._navItemsCount[this.type][propName])
      || !subPart.part._navItemsCount.checkedAfterReceived
      || !(subPart.part.bottomTubId && subPart.part.hideLayerCondition && subPart.part.hideLayerCondition())
      || (subPart.part.nextFeaturesPageToLoadArray && subPart.part.partId === "vanity_countertop")) {
      // added vanity_countertop because of the matching feature omggg
      // added check for replacement tub fixture, it needs to wait until we switch to the replacement tub
      subPart.part._navItemsCount[this.type][propName] = this.designNavigationItems(...props).length
    }
    if (subPart.part.allFeaturesReceived && !subPart.part._navItemsCount.checkedAfterReceived) {
      // stop calling navItems func after all features received and it is calculated
      subPart.part._navItemsCount.checkedAfterReceived = true;
    }
    return subPart.part._navItemsCount[this.type][propName] > 0
  }

  /**
   * Returns the designNavigationItems for the navigation bar
   * @param parentItem {DesignNavigationItem} if null is supplied will return the major designNavigationItems,
   * otherwise the children of the given parent item
   * @param filters {[navigationFilterValueInterface]}
   * @param searchText {string}
   * @param forFeature {object|boolean} // for new kitchen and bathroom it is forFeature, for old - withPlaceholders
   * @param withQuotingToolFeatures {boolean|string}
   * @param filterGroups {array}
   * @param restOptions {object} // firstOpenedFeature = null, firstOpenedConditions = null, returnAllFeatures = false, forActiveQTCategory = ""
   * @returns {Array.<DesignNavigationItem>}
   */
  designNavigationItems(
    parentItem = null,
    filters = [],
    searchText = "",
    forFeature = null,
    withQuotingToolFeatures = false, // could be false(visualizer only), true(quotingtool only), or "all" - all features
    filterGroups = [],
    restOptions = {} // {returnAllFeatures: bool, wizardGroup}
  ) {
    const {forActiveQTCategory, returnAllFeatures} = restOptions;
    //console.log('parentItem', parentItem);
    if (parentItem == null) {
      let partsToShow = this.enabledParts();
      if (!this.type) { // disable window on the small room layout
        partsToShow = partsToShow.filter(parentGroup => parentGroup.partName !== "Window");
      }
      if (document.kvConfig.visualizerType === "KV" || document.kvConfig.visualizerType === "Kitchen") {
        // disable center island
        const layoutAbbreviation = this.getCurrentLayoutAbbreviation();
        if (!layoutAbbreviation.includes("I")) {
          partsToShow = partsToShow.filter(parentGroup => parentGroup.partName !== "CenterIsland");
        }
      }
      return orderBy(partsToShow, ['sortOrder']).map(parentGroup => parentGroup.navigationItem());
    }

    const thirdParam = this.isNewLayout ? forFeature || parentItem.part.activeFeature : forFeature // withPlaceholders

    if (IS_QKB_UI
      && restOptions?.wizardGroup
      && (document.kvConfig.visualizerType === "bvLook")
      && parentItem.part.getUNavigationItems
      && !hardCodeIsAmericanStandard()
      && USE_NEW_NAV
    ) {
      return parentItem.part.getUNavigationItems(filters, searchText, thirdParam, withQuotingToolFeatures, forActiveQTCategory);
    }

    const nItems = parentItem.part.navigationSubItems(
      filters,
      searchText,
      thirdParam,
      filterGroups,
      restOptions
    )
    // console.log("nItems", nItems);
    const navItems = nItems
      .filter(feature => {
        if (!feature || !feature.part) {
          return false
        }
        if (!this.isNewLayout && !thirdParam && feature.part.partName
          && (feature.part.partName.includesCI('placeholder') || feature.part.partName.includesCI('Demo Model'))) {
          return false // exclude placeholders;
        }
        return isVisibleForNavigation(feature.part, withQuotingToolFeatures, forActiveQTCategory)
      });

    return withQuotingToolFeatures || returnAllFeatures
      ? this.getNotAvailableInVisualizerFeatures(navItems, parentItem.part, filters, searchText, forActiveQTCategory)
      : navItems.filter(item => !item.part.notAvailableInVisualizer && isFeatureEnabled(item.part, "visualizer"))
  }

  setGroupsItemsCount(bvGroups) {
    const features = this.getFeatures(true);
    const groupKeys = {};
    Object.keys(bvGroups).map(key => {
      groupKeys[key.toLowerCase()] = key;
    });
    // console.log(groupKeys);
    features.forEach(parentGroup => {
      if (parentGroup.menuType === PartMenuType.Simple) {
        const dbName = (parentGroup.dbName || parentGroup.partName).toLowerCase();
        parentGroup.counts = (groupKeys[dbName] && bvGroups[groupKeys[dbName]])
          ? bvGroups[groupKeys[dbName]].counts
          : null;
        parentGroup.totalFeaturesCount = (groupKeys[dbName] && bvGroups[groupKeys[dbName]])
          ? bvGroups[groupKeys[dbName]].totalFeaturesCount
          : null
        // if (IS_OFFLINE_MODE) { // we will get them from the worker
        //   parentGroup.allFeaturesReceived = true;
        //   parentGroup.realFeaturesReceived = true;
        // }
      } else {
        parentGroup.relatedItems.forEach((relatedItem) => {
          const dbName = (relatedItem.dbName || relatedItem.partName || "").toLowerCase();
          if (relatedItem.partId !== "wall_configuration") {
            relatedItem.counts = (groupKeys[dbName] && bvGroups[groupKeys[dbName]])
                ? bvGroups[groupKeys[dbName]].counts
                : null;
          }
          relatedItem.totalFeaturesCount = (groupKeys[dbName] && bvGroups[groupKeys[dbName]])
            ? bvGroups[groupKeys[dbName]].totalFeaturesCount
            : null;
          if (!relatedItem.counts && !relatedItem.partId.includes("decor")) {
            console.log("no relatedItem.counts", relatedItem)
          }
          // if (IS_OFFLINE_MODE) { // we will get them from the worker
          //   relatedItem.allFeaturesReceived = true;
          //   relatedItem.realFeaturesReceived = true;
          // }
        })
      }
    })
  }

  getNotAvailableInVisualizerFeatures = (filteredAvailableFeatures, subPart, filters, searchText, forActiveQTCategory = "") => {
    if (subPart.getParent && subPart.getParent().partName === "Other") { // not in visualizer features, they don't need another check
      return filteredAvailableFeatures
    }
    const notInVisualizerFeaturesThatLeft = (subPart.features || []).filter(feature => {
      if (feature.partName && feature.partName.includes("laceholder")) {
        return false
      }
      const featureSplittedName = feature.getSplittedFeatureName();
      return feature.notAvailableInVisualizer && isVisibleForNavigation(feature, true, forActiveQTCategory)
        && !filteredAvailableFeatures.some(countertop => {
          return countertop.part.getSplittedFeatureName() === featureSplittedName
        })
    })

    let allNotAvailableFeatures = subPart.getFeaturesBySearchText(subPart.getFilteredFeaturesByFilters(filters, notInVisualizerFeaturesThatLeft), searchText);
    allNotAvailableFeatures = subPart.returnUniqueNavFeatures
      ? subPart.returnUniqueNavFeatures(allNotAvailableFeatures)
      : allNotAvailableFeatures.map(_ => new DesignNavigationItem(_.featureName, _));

    return [
      ...filteredAvailableFeatures,
      ...allNotAvailableFeatures
    ]
  }

  /**
   * returns enabled parts
   */
  enabledParts(withShadow) {
    return this.getFeatures(withShadow).filter(parentGroup => parentGroup.categoryEnabled);
  }

  async selectLayout(type, oldType, currentState = null, scene = this.scene, callBack, isFake = false) {
    const firstLoad = false; // change if needed
    const features = this.getFeatures(true); // true here cause we need backgrounds also to set default!
    const currentType = oldType || this.type;  // 1) remember previous selection

    //  2) save the current state using feature names, then restore it after the layout has changed
    currentState = currentState || this.getActiveFeaturesAsObject(true, false, true);

    if (getCurrentRoomType(this) === LOOK_ROOM_TYPES.as || Config.isVisualizerManagement()) {
      currentState.disabled_parts = [];
    }

    // 3) save selected features to recover them after layout change back (if they were not found after current set)
    this.selectedLayoutFeatures[currentType] = currentState;

    this.type = type; // 4) apply new Layout
    this.scene = currentType !== type ? "1" : scene; // 4) apply new scene // set first scene if layout is changed
    currentState.scene = this.scene; // 4) apply new scene
    currentState.layout_type = type; // 4) apply new layout_type

    features.forEach(parentGroup => {
      parentGroup.setDefault(this); // setting default after
    });

    this.setActiveFeaturesFromObject(currentState, false, true, false, firstLoad, isFake); // 6) set the layers from previous layout
    this.changeLayout(this.getFeatures());    // 7) set specific rules for each part
    if (!isFake) {
      $(window).trigger(ActionTypes.CHANGE_LAYOUT);   // 8) refresh canvas
      this.updateLocalStorage();
    }
    if (callBack) {
      callBack()
    }
    console.log("this fake", this);
    return Promise.resolve()
  }

  setItemsFromBvState = async (bvState,
                               isCartAndUserStatedUpdateNeeded= false,
                               additionalSet = (bvState) => bvState,
                               firstLoad = false,
                               forVisualizer
  ) => {
    const neededDbFeatures = getArrayOfIdsFromBvState(bvState).filter(dbFeatureId => {
      return !Object.keys(this.allDbFeatures).some(groupName => {
        return this.allDbFeatures[groupName].some(feature => feature.id === dbFeatureId)
      })
    });
    const response = neededDbFeatures.length
      ? await getBvFeatures(
        neededDbFeatures,
        null,
        false,
        forVisualizer,
        "",
        null,
        null,
        firstLoad
      )
      : {data: []}

    // console.log('getBvFeatures response->', responseFeatures);

    // this code is needed because we need to loadNewFeatures for already setted layout type
    bvState = bvState || {};
    const layout_type = +bvState.layout_type;
    const needToChangeLayout = (layout_type || layout_type === 0) && (layout_type !== +this.type);
    if (needToChangeLayout) {
      this.type = layout_type;
    }
    this.loadNewFeatures(response.data);
    if (typeof additionalSet === "function") {
      bvState = additionalSet(bvState);
    }
    this.setActiveFeaturesFromObject(bvState, isCartAndUserStatedUpdateNeeded, false, true, firstLoad);
    if (this.isNewLayout && firstLoad) {
      this.createCustomConfigurations();
    }
    await requestAfterRoomChange(this);
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS);
    return response
  };

  changeLayout(features) {
    features.forEach(parentGroup => {
      parentGroup.changeLayout(this.type);
      parentGroup.relatedItems.forEach(ri => ri.changeLayout(this.type));
    });
  }

  getFeatures(withShadow = false) {
    return withShadow ? values(this.parts) : values(this.parts).filter(part => {
      return ["Global Shadow", "Globals", "Other", "Background", "Backgrounds"].every(groupName => part.partName !== groupName)
    });
  }

  fixFeatureBeforeLoad(dbFeature) {
    dbFeature = fixDbFeatureProperties(dbFeature);
    if (Array.isArray(dbFeature.metaData.RoomLayout)) {
      dbFeature = this.fixFeatureMetaData(dbFeature)
    }
    return dbFeature
  }

  loadNewFeatures(dbFeatures = [], forParentGroup = null, applyCustomConfigurations = true, forNextBvState = null) {
    //features could be also loaded directly to the part, check part.js -> setGroupFeatures method

    //dbFeatures can be an object! {features:[], relatedFeatures: []}
    const dbFeaturesArray = fixFeaturesResponse(dbFeatures);

    const parentGroups = this.getFeatures(true);
    let relatedFeatures = [];

    let loadedDbFeatures = null;
    if (forParentGroup && dbFeatures[0] && ((forParentGroup.dbName || forParentGroup.partName) === dbFeatures[0].groupName)
      && this.allDbFeatures[dbFeatures[0].groupName?.toLowerCase()]) {
      loadedDbFeatures = this.allDbFeatures[dbFeatures[0].groupName?.toLowerCase()].slice();
      // console.log("loadedDbFeatures", loadedDbFeatures);
    }

    for (let i = 0; i < dbFeaturesArray.length; i++) {
      let dbFeature = dbFeaturesArray[i];
      if (!dbFeature) {
        continue;
      }
      dbFeatureRelatedFeaturesProperties.forEach(property => {
        if (Array.isArray(dbFeature[property]) && dbFeature[property].length) {
          dbFeature[property].forEach(relatedFeature => {
            if (relatedFeatures.some(relFeature => relFeature.id === relatedFeature.id)) {
              return
            }
            relatedFeatures.push(relatedFeature)
          });
          // console.log("dbFeature.relatedFeatures", dbFeature.relatedFeatures);
        }
      })
      this.loadDbFeature(dbFeature, parentGroups, forParentGroup, loadedDbFeatures)
    }

    if (relatedFeatures.length) {
      for (let i = 0; i < relatedFeatures.length; i++) {
        this.loadDbFeature(relatedFeatures[i], parentGroups)
      }
    }

    if (document.kvConfig.visualizerType === "bvLook" && applyCustomConfigurations) {
      const isAsBathroomState = forNextBvState && forNextBvState.visualizerType === "bvLook" && forNextBvState.layout_type >= 10;
      this.createCustomConfigurations(isAsBathroomState);
    }

    return true
  }

  fixFeatureMetaData(dbFeature) {
    // it is needed only for bvScene - it has it's own method
    // dbFeature.metaData.RoomLayout = dbFeature.metaData.RoomLayout.map((mValue) => {
    //   Object.values(LayoutType).map(val => val + "").forEach(stringNum => {
    //     if (mValue === stringNum) {
    //       mValue = "Layout" + mValue
    //     }
    //   })
    //   return mValue
    // })
    return dbFeature
  }

  loadDbFeature(dbFeature, parentGroups, forParentGroup = null, allDbFeaturesToCheck = null) {
    if (!dbFeature || (dbFeature.employeesOnly && !document.kvConfig.isBackend)) {
      return;
    }
    const loadedDbFeatures = allDbFeaturesToCheck || this.allDbFeatures[dbFeature.groupName?.toLowerCase()];
    if (loadedDbFeatures && loadedDbFeatures.length) {
      for (let i = 0; i < loadedDbFeatures.length; i++) {
        if (loadedDbFeatures[i].id === dbFeature.id) {
          // console.log("featureFound", featureFound);
          updateExistingFeature(dbFeature, loadedDbFeatures[i], this);
          return;
        }
      }
    }
    dbFeature = this.fixFeatureBeforeLoad(dbFeature);
    let loaded = false;
    if (forParentGroup && !forParentGroup.shouldLoadInMultipleGroups // they should be in separate groups
      && (forParentGroup.dbName === dbFeature.groupName || forParentGroup.partName === dbFeature.groupName)) {
      loaded = forParentGroup.load(dbFeature);
    }
    if (!loaded) {
      for (let i = 0; i < parentGroups.length; i++) {
        const parentGroup = parentGroups[i];
        loaded = parentGroup.load(dbFeature);
        if (loaded) {
          break;
        }
      }
      if (!loaded && this.parts["Other"]) {
        this.parts["Other"].load(dbFeature);
      }
    }
    // dbFeature.isRelatedDbFeature ? this.allDbFeatures[dbFeature.groupName].unshift(dbFeature) : this.allDbFeatures[dbFeature.groupName].push(dbFeature);
    const groupKey = dbFeature.groupName?.toLowerCase();
    if (!this.allDbFeatures[groupKey]) {
      this.allDbFeatures[groupKey] = [];
    }
    this.allDbFeatures[groupKey].push(dbFeature);
  }

  createCustomConfigurations(isAsBathroomState = null) {
    // after load callBack for each part(to set specific rules)
    this.getFeatures().forEach(parentGroup => {
      parentGroup.setSpecificRules ? parentGroup.setSpecificRules(isAsBathroomState) : null;
    });
  }

  setDefaultFeatures() {
    this.getFeatures(true).forEach(parentGroup => {
      parentGroup.setDefault(this);
    });
  }

  /**
   * Returns all features by text
   */

  getAllFeaturesByText(searchText) {
    let allFeatures = [];
    this.getFeatures().forEach((parentGroup) => {
      let subParts = parentGroup.subParts();
      subParts.forEach((subPart) => {
        allFeatures = [...allFeatures, ...subPart.part.features.filter(feature => feature.partName && feature.partName.toLowerCase().includes(searchText.toLowerCase()))]
      })
    });
    // console.log('allFeatures', allFeatures);
    return allFeatures
  }

  /**
   * Returns all features
   * @param withOtherGroups {boolean}
   */

  getAllFeatures(withOtherGroups = false) {
    let allFeatures = [];
    this.getFeatures(withOtherGroups).forEach((parentGroup) => {
      let subParts = parentGroup.subParts();
      subParts.forEach((subPart) => {
        allFeatures = [...allFeatures, ...subPart.part.features]
      })
    });
    // console.log('allFeatures', allFeatures);
    return allFeatures
  }

  /**
   * Returns all featureGroups
   * @param withOtherGroups {boolean}
   */

  getAllFeatureGroups(withOtherGroups = true) {
    return this.getFeatures(withOtherGroups).reduce((allFeatures, parentGroup) => {
      parentGroup.subParts().forEach((subPart) => {
        if (!subPart || !subPart.part || allFeatures.some(featureGroup => {
          return featureGroup.partId === subPart.part.partId
        })) {
          return
        }
        allFeatures.push(subPart.part);
      });
      return allFeatures;
    }, []);
  }

  /**
   * Returns feature
   * @param neededId {number}
   * @param withOtherGroups {boolean}
   * @returns feature {object}
   */
  getFeatureById(neededId, withOtherGroups = false) {
    let feature = null;
    this.getFeatures(withOtherGroups).forEach((parentGroup) => {
      if (!feature) {
        let subParts = parentGroup.subParts();
        subParts.forEach((subPart) => {
          if (!feature) {
            feature = subPart.part.getFeatureById(neededId, true);
          }
        })
      }
    });
    return feature
  }

  /**
   * Returns feature
   * @param skuNumber {string}
   * @param featureGroupPartId {string}
   * @param allLayouts {boolean}
   * @param withSharedFeatureName {boolean}
   * @returns feature {object}
   */
  getFeatureBySku(skuNumber, featureGroupPartId= "", allLayouts = false, withSharedFeatureName = false) {
    const propToSearch = withSharedFeatureName ? "sharedFeatureName" : "sku";
    if (featureGroupPartId) {
      const featureGroupFound = this.getFeatureGroupByPartId(featureGroupPartId);
      if (featureGroupFound) {
        if (featureGroupFound && featureGroupFound.activeFeature && featureGroupFound.activeFeature.dbFeature[propToSearch] === skuNumber) {
          return featureGroupFound.activeFeature
        }
        const searchFrom = featureGroupFound.getFeaturesForNavigationFrom
          ? featureGroupFound.getFeaturesForNavigationFrom({returnAllFeatures: allLayouts})
          : featureGroupFound.features;
        for (let i = 0; i < searchFrom.length; i++) {
          if (searchFrom[i].dbFeature[propToSearch] === skuNumber) {
            return searchFrom[i];
          }
        }
      }
    }
    const allParents = this.getFeatures(true);
    for (let i = 0; i < allParents.length; i++) {
      const subParts = allParents[i].subParts();
      for (let j = 0; j < subParts.length; j++) {
        const featureGroup = subParts[j].part;
        if (featureGroup.activeFeature) {
          if (featureGroup.activeFeature.dbFeature[propToSearch] === skuNumber) {
            return featureGroup.activeFeature
          }
          const features = [...featureGroup.features, ...featureGroup.featuresParts];
          const sameSkuFeatures = features.filter(feature => feature.dbFeature[propToSearch] === skuNumber);
          if (!sameSkuFeatures.length) {
            continue;
          }
          if (featureGroup.activeFeature.metaData["Side"]) {
            const sameSide = sameSkuFeatures.find(feature => {
              return isEqual(feature.metaData["Side"], featureGroup.activeFeature.metaData["Side"])
            });
            if (sameSide) {
              return sameSide
            }
          }
          return sameSkuFeatures[0]
        } else {
          for (let k = 0; k < featureGroup.features.length; k++) {
            if (featureGroup.features[k].dbFeature[propToSearch] === skuNumber) {
              return featureGroup.features[k];
            }
          }
        }
      }
    }
    return null
  }

  /**
   * Returns active installations
   */
  getActiveInstallations() {
    const {instState} = store.getState();
    return Object.assign({}, instState, {instOpened: false});
  }

  addCartAndUserStatesToLocalStorage(bvState) {
    const {cartState, userState, sqftState, bathroomVisualizerState, wizardState, fabricatorState, aiState} = store.getState();

    bvState.cartState = getCartStateForLocalStorage(cartState);

    const lookId = getLookId(bathroomVisualizerState.activePreset, bathroomVisualizerState.bvPresets);
    bvState.userState = userState;
    bvState.id = bathroomVisualizerState.activePreset;
    bvState.lookId = lookId;
    bvState.useSqftCartPopup = sqftState ? sqftState.sqftFeaturesPopup.enabled : false;
    bvState.useFabricatorCostPrices = fabricatorState.settings.useFabricatorCostPrices;
    if (wizardState.wizardIsActive) {
      bvState.allWizardsValues = getCompressedAllWizardValues(wizardState.allWizardsValues);
    }
    bvState = getFeatureGroupsProperties(bvState, this);
    bvState.aiExportData = getExportAIData(aiState);
    return bvState
  }

  /**
   * Returns activeFeatures object
   */

  getStonesActiveFeatures() {
    return this.getActiveFeatures(true).filter(activeFeature => activeFeature.cartFeature && activeFeature.cartFeature.isStoneFeature)
  }

  addDisabledPartsToLocalStorage(bvState) {
    const disabledPartIds = this.getDisabledFeatures();
    if (disabledPartIds.length) {
      bvState.disabled_parts = disabledPartIds;
    }
    return bvState
  }

  /**
   * @param useNames {boolean}
   * @param returnAllData {boolean}
   * @param returnAllFeatures {boolean}
   */
  getActiveFeaturesAsObject(useNames = false, returnAllData = true, returnAllFeatures = false) {
    let bvState = {};
    let activeFeatures = this.getActiveFeatures(returnAllFeatures, false, true);
    // console.log('activeFeatures', activeFeatures);
    activeFeatures.forEach((activeFeature) => {
      if (!activeFeature.cartFeature) {
        return
      }
      bvState[activeFeature.partId] = useNames
        ? activeFeature.cartFeature.getMatchingFeatureName()
        : activeFeature.cartFeature.dbFeature.id;
    });

    bvState.visualizerType = this.visualizerType; // to apply correct visualizer on quote open after save
    bvState.toolVersion = document.kvConfig.toolVersion; // to apply correct visualizer on quote open after save
    bvState.navigationType = document.kvConfig.navigationType; // to open in dashboard correct UI;

    bvState = this.addSpecificPropertiesToLocalStorage(bvState, useNames, returnAllFeatures);
    bvState = this.addDisabledPartsToLocalStorage(bvState);
    bvState.bvStateVersion = 2; //todo to test

    if (returnAllData) {
      bvState.installations = this.getActiveInstallations();
      bvState = this.addCartAndUserStatesToLocalStorage(bvState);
    }

    return bvState
  }

  /**
   * @param dbFeatureId {number}
   * @param featureGroup {featureGroupInterface}
   * @param featuresToLoad {array}
   * @return {featureInterface}
   */
  getLoadedFeatureById = (dbFeatureId, featureGroup, featuresToLoad = []) => {
    if (!featureGroup) {
      return null
    }
    let featureLoaded = featureGroup.features.find((feature) => feature.dbFeature.id === dbFeatureId);
    if (!featureLoaded && featureGroup.featuresParts) {
      featureLoaded = featureGroup.featuresParts.find((feature) => feature.dbFeature.id === dbFeatureId);
    }
    if (!featureLoaded) { // if feature isn't found in the current layout, let's find it in another layouts
      let allFeatures = [];
      Object.keys(this.layoutNames).forEach((layoutType) => {
        if (layoutType !== "All") {
          allFeatures = [...allFeatures, ...featureGroup.featuresList[layoutType]]
        }
      });
      featureLoaded = allFeatures.find((feature) => feature.dbFeature.id === dbFeatureId);
      if (!featureLoaded
        && (document.kvConfig.visualizerType === "Kitchen" || document.kvConfig.visualizerType === "kvScene")
        && this.qtCategories && this.qtCategories.some(qtCat => qtCat.qtCategoryHasBeenChanged)
        && featuresToLoad.length
      ) {
        // console.info("Cart feature is not loaded, trying in change categories:", dbFeatureId);
        this.qtCategories.forEach(qtCat => {
          const changedSubPart = qtCat.subParts.find(subPart => {
            return subPart.part.partId === featureGroup.partId
          });
          if (changedSubPart) {
            // console.info("Cart feature is not loaded, found subpart:", ci);
            const needToLoadFeature = featuresToLoad.find(dbFeature => dbFeature.id === dbFeatureId);
            if (needToLoadFeature) {
              changedSubPart.part.setGroupFeatures([needToLoadFeature], 0, false)
            }
            featureLoaded = featureGroup.features.find((feature) => {
              return feature.dbFeature.id === dbFeatureId
            });
            // if (featureLoaded) {
            // console.info("Cart feature is not loaded, it's ok, we found it:", dbFeatureId, featureLoaded);
            // }
          }
        })
      }
      // console.log('featureLoaded', featureLoaded);
      if (!featureLoaded) {
        console.error("Cart feature is not loaded:", dbFeatureId);
      }
    }
    return featureLoaded
  }

  /**
   * Get Cart Items From BvState
   * @param cartItems {Array}
   * @param featuresToLoad {Array} // only if layout is changed - we need to load features to changed feature group
   * @param checkAllLayouts {boolean}
   * @param wizardState {object}
   * @return {Array}
   */
  getCartItemsFromBvState(cartItems = [], featuresToLoad = [], checkAllLayouts = false, wizardState) {
    // const slabGroup = getSimilarFeatureGroup(SQFT_FEATURES.slabs, SQFT_FEATURES.slabs);
    // parentItems.push(slabGroup);

    const setCustomPrices = (feature, fromCartItem) => {
      if (feature && feature.dbFeature && fromCartItem && fromCartItem.cartFeature && fromCartItem.cartFeature.hasOwnProperty("customCost")) {
        feature.dbFeature.priceWasChanged = true;
        feature.dbFeature.cost = fromCartItem.cartFeature.customCost;
        feature.dbFeature.fabricatorCost = fromCartItem.cartFeature.customCost;
        feature.dbFeature.price = fromCartItem.cartFeature.customPrice;
      }
    }

    return cartItems
      .map(ci => {

        const layout = checkAllLayouts && ci.fromVisualizerType ? getCurrentLayout(ci.fromVisualizerType) : this;
        if (layout.isNewLayout) {
          const partId = getCartItemPartIdFix(ci.partId);
          let cartFeature = layout.getFeatureFromAllLayouts(ci.partId, ci.cartFeature, featuresToLoad);
          setCustomPrices(cartFeature, ci);
          let newCartItem = Object.assign({}, ci, {
            partId,
            currentQuote: ci.currentQuote || 0,
            cartFeature: cartFeature
          });
          if (ci.relatedProductParent) {
            newCartItem.relatedProductParent = layout.getFeatureFromAllLayouts(ci.relatedProductParent.partId, ci.relatedProductParent, featuresToLoad);
          }
          if (ci.bundleParentId) {
            newCartItem.bundleParentId = ci.bundleParentId;
          }
          ci = updateCartItemWizardValues(ci, wizardState);
          if (cartFeature && cartFeature.dbFeature) { //if we couldn't find feature then we will try to restore it from old layout
            return newCartItem
          }
        }

        const parentItems = layout.getFeatures(true);
        const dbFeatureId = ci.cartFeature.dbFeatureId || ci.fabFeatId || (ci.cartFeature.dbFeature ? ci.cartFeature.dbFeature.id : null); //old logic support
        if (!dbFeatureId) {
          console.log("NO DB FEATURE ID", ci);
        }
        const ciFeature = ci.cartFeature; // we have to remember what has come from backend to be able to restore custom price
        ci.cartFeature = ci.cartFeature || {};
        ci.partId = getCartItemPartIdFix(ci.partId);
        ci.currentQuote = ci.currentQuote || 0;
        let childSubPart = null;
        parentItems.forEach(parentGroup => {
          if (childSubPart || !parentGroup) {
            return
          }
          if (ci.partId === SQFT_FEATURES.slabs) {
            childSubPart = getSlabsFeatureGroup(layout);
            childSubPart = childSubPart.part ? childSubPart.part : childSubPart
          } else {
            //changed subParts() to relatedItems because on this task QCDES-2593
            childSubPart = parentGroup.relatedItems.find(relItem => relItem.partId === ci.partId);
          }
          if (childSubPart && childSubPart.features) {
            ci.cartFeature = layout.getLoadedFeatureById(dbFeatureId, childSubPart, featuresToLoad);
          }
        });
        setCustomPrices(ci.cartFeature, {cartFeature: ciFeature});
        ci = updateCartItemWizardValues(ci, wizardState);
        if (!ci.cartFeature || !ci.cartFeature.dbFeature) {
          console.error("cartFeature not loaded!", ci);
        }
        return ci
      })
      .filter(ci => ci.cartFeature && ci.cartFeature.dbFeature); //prevent error's that are caused by missing feature
  }

  bvStateHasLockedItems(bvState) {
    return this.getFeatures().some((parentGroup) => {
      let partDataHasLockedItems = false;
      if (parentGroup.menuType === 0 && parentGroup.partName !== "Toilet") {
        const partId = parentGroup.partId;
        if (bvState.hasOwnProperty(partId)) {
          const feature = parentGroup.getFeatureById(bvState[partId]);
          if (feature && !feature.dbFeature.unlocked) {
            // console.log('found!', feature);
            partDataHasLockedItems = true;
          }
        }
      } else {
        let subParts = parentGroup.relatedItems;
        subParts.forEach((subPart) => {
          const partId = subPart.partId;
          if (bvState.hasOwnProperty(partId)) {
            const feature = subPart.getFeatureById(bvState[partId]);
            if (feature && !feature.dbFeature.unlocked) {
              // console.log('found!', feature, index);
              partDataHasLockedItems = true;
            }
            // if (partId === "shower_body") {
            // }
          }
        })
      }
      return partDataHasLockedItems
    });
  }

  /**
   * @param qtCategories {array}
   * @return void // creates array of featureGroups features and loads them. skips already loaded
   */
  loadFeatureGroupFeatures = (qtCategories) => {
    let featureGroupFeatures = [];
    let needToLoadFeatureGroupsFeatures = [];
    // qtCategories.forEach(qtCategory => {
    //   qtCategory.featureGroups.forEach(featureGroup => {
    //     if (featureGroup.features && featureGroup.features.length) {
    //       featureGroup.features.forEach(dbFeature => {
    //         if (!dbFeature.metaData) {
    //           console.log("no metadata found", dbFeature);
    //         }
    //       })
    //     }
    //   });
    // });
    const parentParts = this.getFeatures();
    qtCategories
      .filter(qtCategory => {
        return qtCategory.enabled && qtCategory.featureGroups.some(featureGroup => featureGroup.enabled)
      })
      .forEach(qtCategory => {
        qtCategory.featureGroups
          .filter(featureGroup => {
            const groupName = featureGroup.groupName.toLowerCase();
            for (let i = 0; i < parentParts.length; i++) {
              const parentPart = parentParts[i];
              const subPartItems = parentPart.subParts();
              const item = subPartItems.find(subPartItem => {
                const dbName = (subPartItem.part.dbName || subPartItem.part.partName).toLowerCase();
                return groupName === dbName
              });
              if (item) {
                const navItems = this.designNavigationItems(item, {}, "", false, true);
                if (!navItems.length && !needToLoadFeatureGroupsFeatures.some(sPart => sPart.part.partId === item.part.partId)) {
                  needToLoadFeatureGroupsFeatures.push(item);
                }
                // console.log("features already exist:", groupName);
                return false
              }
            }
            return true
          })
          .forEach(featureGroup => {
            if (featureGroup.features && featureGroup.features.length) {
              featureGroupFeatures = [...featureGroupFeatures, ...featureGroup.features]
            }
          });
      });
    this.loadNewFeatures(featureGroupFeatures, null, false);
    return needToLoadFeatureGroupsFeatures
  };

  addSubPartProperties(subPart, featureGroup, qtCategory, isComplex = false) {
    subPart.part.qtCategoryName = qtCategory.name;
    subPart.part.featureGroupVisible = featureGroup.visible;
    subPart.part.featureGroupEnabled = featureGroup.enabled;
    subPart.part.displayType = featureGroup.displayType || 3;
    subPart.part.featureGroupEnabled = featureGroup.enabled;
    subPart.part.unitText = featureGroup.unitText;
    subPart.hasFeatures = featureGroup.hasFeatures;
    if (!isComplex) {
      subPart.part.customGroupDisplayName = featureGroup.customDisplayName;
      subPart.part.description = featureGroup.description;
      subPart.part.customDescription = featureGroup.customDescription;
      subPart.part.customImageUrl = featureGroup.customImageUrl ? baseDashboardImagesPath + featureGroup.customImageUrl : "";
      if ((this.visualizerType === AVAILABLE_VISUALIZER_TYPES.kvScene)) {
        if (subPart.part.partId === "center_island_sink") {
          const anotherFg = this.getFeatureGroupByPartId("sink");
          if (anotherFg) {
            anotherFg.customGroupDisplayName = subPart.part.customGroupDisplayName;
            anotherFg.description = subPart.part.description;
            anotherFg.customDescription = subPart.part.customDescription;
            anotherFg.customImageUrl = subPart.part.customImageUrl;
          }
        } else if (subPart.part.partId === "center_island_faucet") {
          const anotherFg = this.getFeatureGroupByPartId("faucet");
          if (anotherFg) {
            anotherFg.customGroupDisplayName = subPart.part.customGroupDisplayName;
            anotherFg.description = subPart.part.description;
            anotherFg.customDescription = subPart.part.customDescription;
            anotherFg.customImageUrl = subPart.part.customImageUrl;
          }
        }
      }
    }
    /*** HERE WE SET SAME PROPERTIES FOR SPECIFIC QT Category ***/
    let qtCatProperties = {
      qtCategoryId: qtCategory.id,
      qtCategoryName: qtCategory.name,
      featureGroupVisible: featureGroup.visible,
      featureGroupEnabled: featureGroup.enabled,
      // hasFeatures: featureGroup.hasFeatures, // NOT SURE WHERE WE NEED THAT
    }
    if (!isComplex) {
      qtCatProperties.customGroupDisplayName = featureGroup.customDisplayName;
      qtCatProperties.description = featureGroup.description;
      qtCatProperties.customDescription = featureGroup.customDescription;
      qtCatProperties.customImageUrl = featureGroup.customImageUrl ? baseDashboardImagesPath + featureGroup.customImageUrl : "";
    }
    if (!subPart.part.qtCatProperties) {
      subPart.part.qtCatProperties = {};
    }
    subPart.part.qtCatProperties[qtCategory.name] = qtCatProperties;
  }

  get qtCategories() {
    //NOTA BENE !!! kitchen layout has it's own get qtCategories() method
    return this.qtCategoriesList
  }

  setQtCategoriesSubparts(qtCategories) {
    // if (IS_QKB_UI && Array.isArray(qtCategories) && qtCategories.some(qtCat => qtCat.useWizard)) {
    //   return // why do we have to do it?
    // }
    const parentParts = [...this.getFeatures(), this.parts["Other"]];
    // console.log('parentParts', parentParts);
    let hasFeaturePropertyName = getCommonVisualizerType(this.visualizerType);
    this.qtCategoriesList = qtCategories
      .map(qtCategory => {  //todo remove this after we push staging backend
        if (Array.isArray(qtCategory.featureGroups)) {
          qtCategory.featureGroups = qtCategory.featureGroups.map((featureGroup) => {
            if (this.isNewLayout) { // ignoreHasFeaturesProperty
              featureGroup.hasFeatures = {
                bathroom: true,
                kitchen: true,
                fireplace: true,
                laundryroom: true,
              }
            } else if (!featureGroup.hasFeatures) {
              featureGroup.hasFeatures = {
                bathroom: featureGroup.hasBVFeatures,
                kitchen: featureGroup.hasKVFeatures,
                fireplace: true,
                laundryroom: true,
              }
            }
            if (featureGroup.hasFeatures[hasFeaturePropertyName] && Array.isArray(featureGroup.features)
              && (featureGroup.features.length > 0 && featureGroup.features.length < 50)
              && !featureGroup.features.some(dbFeature => isFeatureEnabled({dbFeature}, "quotingTool", "", hasFeaturePropertyName))) {
              // this is a fix we need to do on the backend! if features.length is more than 50 and they all are disabled
              // for QuotingTool - hasFeatures.bathroom should be false!
              featureGroup.hasFeatures[hasFeaturePropertyName] = false
            }
            return featureGroup
          })
        }
        return qtCategory
      })
      .filter(qtCategory => {
        return qtCategory.enabled // 1) remove disabled qtCategories
          && Array.isArray(qtCategory.featureGroups) && qtCategory.featureGroups.some((featureGroup) => {
            return featureGroup.hasFeatures && featureGroup.hasFeatures[hasFeaturePropertyName] // 1) remove qtCategories without visualizerTypeFeatures
          })
      })
      .sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0) // sort by order
      .map((qtCategory) => {
        let subParts = [];
        qtCategory.featureGroups
          .filter(featureGroup => {
            const featureGroupName = featureGroup.groupName.toLowerCase();
            return featureGroupName !== "walls"
          }) // remove walls featureGroup // clone.quotesflooring.com/visualizer#/ issue
          .sort((a, b) => a.order !== b.order ? a.order < b.order ? -1 : 1 : 0) // sort by order
          .forEach(featureGroup => {
            let subPart = null;
            const featureGroupName = featureGroup.groupName.toLowerCase();
            // if (featureGroupName === "walls") {
            //   const wallsParent = parentParts.find(parentPart => parentPart.partName === "Walls");
            //   if (wallsParent) {
            //     subParts = [...subParts, ...wallsParent.subParts().map(wallsSubPart => {
            //       this.addSubPartProperties(wallsSubPart, featureGroup, qtCategory, false);
            //       return wallsSubPart
            //     })];
            //   }
            // } else {
            //
            // }
            for (let i = 0; i < parentParts.length; i++) {
              const parentPart = parentParts[i];
              const subPartItems = parentPart.relatedItems.map(_ => new DesignNavigationItem(_.partName, _));
              const item = subPartItems.find(subPartItem => {
                if (featureGroupName === "shower pan" && document.kvConfig.visualizerType === "bvScene") {
                  const dbName = (subPartItem.part.dbName || "").toLowerCase();
                  const dbName2 = (subPartItem.part.partName || "").toLowerCase();
                  return featureGroupName === dbName || featureGroupName === dbName2
                } else if (featureGroupName === "vanity" && document.kvConfig.visualizerType === "bvLook") {
                  return subPartItem.part.partId === 'vanity_cabinet'
                }
                const dbName = (subPartItem.part.dbName || subPartItem.part.partName || "").toLowerCase();
                // if (featureGroupName === dbName && (this.visualizerType === AVAILABLE_VISUALIZER_TYPES.kvScene)) {
                  // if (dbName === "sink" && (subPartItem.part.partId === "center_island_sink")) {
                  //   return false // we should show back countertop sink instead of sink on the new Kitchen
                  // } else if (dbName === "faucet" && (subPartItem.part.partId === "center_island_faucet")) {
                  //   return false // we should show back countertop faucet instead of faucet on the new Kitchen
                  // }
                // }
                return featureGroupName === dbName
              });
              if (item) {
                subPart = item;
                this.addSubPartProperties(subPart, featureGroup, qtCategory, false);
                break;
              }
            }
            if (!subPart) { // add it to Other group
              subPart = this.addNonVisualizerSubPart(featureGroup.groupName);
              this.addSubPartProperties(subPart, featureGroup, qtCategory, false);
            }
            subParts.push(subPart)
          });

        const self = this;

        const defaultSubParts = subParts.filter(subPart => {
          return subPart && subPart.part.featureGroupEnabled
            && (subPart.part.featureGroupVisible || (!subPart.part.featureGroupVisible && document.kvConfig.isBackend))
            && subPart.hasFeatures && subPart.hasFeatures[hasFeaturePropertyName]
        });

        return {
          id: qtCategory.id,
          name: qtCategory.name,
          order: qtCategory.order,
          bgImageUrl: qtCategory.bgImageUrl,
          defaultSubParts, // is used for center island replacing
          _subParts: defaultSubParts, // remove featureGroups that are !enabled && !visible (eye ball) && has features
          get subParts() {
            return this._subParts.filter((subPart) => {
              const restOptions = window.location.hash.includes("#/materials") ? {forActiveQTCategory: qtCategory.name} : {};
              return self.hasNavItemsLength(subPart, {}, "", null, true, [], restOptions)
            });
          },
          set subParts(newSubParts) {
            this._subParts = newSubParts
          }
        }
      })
      .filter(qtCategory => qtCategory.defaultSubParts.length);  // this filter is added in case someone added wrong featureGroup

    if (!this.qtCategoriesList.length) {
      this.qtCategoriesList = null;
    }

    if (this.qtCategoriesList) {
      // here we set for every subPart if it is available in the QuotingTool(exist in some qtCategory)
      for (let i = 0; i < parentParts.length; i++) {
        const parentPart = parentParts[i];
        const subPartItems = parentPart.subParts();
        subPartItems.forEach(subPartItem => {
          subPartItem.part.existInQtCategory = this.qtCategoriesList.some(qtCategory => {
            return qtCategory.subParts.some(qtCategorySubPartNavItem => {
              return qtCategorySubPartNavItem.part.partId === subPartItem.part.partId
            })
          });
          // console.log("subPartItem.part.existInQtCategory", subPartItem.part.partId, subPartItem.part.existInQtCategory);
        });
      }
    }

    store.dispatch(setQtCategoriesLoaded(this.visualizerType))

  }

  /**
   * Returns the actual value of the filter by its group and id
   * @param groupId {number}
   * @param filterValueId {number}
   */
  static filterValue(groupId, filterValueId) {
    const filterGroups = store.getState().filterState.filterGroups;
    if (!filterGroups.length)
      return null;
    const group = find(filterGroups, {id: groupId});
    if (!group)
      return null;
    const valueObj = find(group.values, {id: filterValueId});
    return valueObj ? valueObj.value.trim() : null;
  }

  /**
   * Returns the actual id of the filter by its group and name(filterValue)
   * @param groupId {number}
   * @param filterValue {string}
   */
  static getfilterValueIdByValue(groupId, filterValue) {
    const filterGroups = store.getState().filterState.filterGroups;
    if (!filterGroups.length)
      return null;
    const group = find(filterGroups, {id: groupId});
    if (!group)
      return null;
    const valueObj = find(group.values, {value: filterValue});
    return valueObj ? valueObj.id : null;
  }

  /**
   * Returns the child subPart according to passed partId
   * @param partId {string}
   */
  getSubPartByPartId(partId) {
    const parentItems = this.getFeatures(true);
    for (let i = 0; i < parentItems.length; i++) {
      const subParts = parentItems[i].subParts();
      const neededSubPart = subParts.find(subPart => subPart.part.partId === partId);
      if (neededSubPart) {
        return neededSubPart
      }
    }
    return null
  }

  /**
   * stores to localStorage object, for example {vanity_cabinet:12,shower_floor:74}
   */
  async updateLocalStorage() {
    // if (IS_LIXIL_UI && !document.kvConfig.isWordpressPlugin) { // now we do
    //   return false // we are not restoring the state from the locale storage on lixil ui, so why do we keep it there
    // }
    const storeState = store.getState();
    if (IS_LIXIL_UI && ((storeState.lookState.lookOverlayOpened && (storeState.lookState.lookOverlayOpened !== LOOK_OVERLAYS.aiPanel))
      || !storeState.serverState.visualizersLoaded.length)) {
      // prevent updating localStorage on restore question popup
      return false
    }
    const {activeQuoteIndex} = storeState.quotesState;
    const quotes = await updateCurrentQuote(null, undefined, true);
    if (!document.kvConfig.jobId) {
      try {
        setLocalStorageState(this.localStorageKey, JSON.stringify({
          ...quotes[activeQuoteIndex].data,
          quotes,
          activeQuoteIndex
        }));
        // console.log("updated LocalStorage", window.localStorage);
      } catch (ex) { console.log("localStorage exception", ex); }
    }
  }

  setCartStateAndUserStateFromBvState(bvState, featuresToLoad = []) {
    const storeState = store.getState();
    const {isLixil, settings} = storeState.fabricatorState;

    setFeatureGroupsProperties(bvState, this);
    if (bvState.aiExportData) {
      store.dispatch(setLookAiImportData(bvState.aiExportData))
    }
    if (bvState.cartState && Array.isArray(bvState.cartState.cartItems)) {
      bvState.cartState.cameFromPage = restoreCameFromPageFromLocalStorage(bvState.cartState.cameFromPage, this);
      bvState.cartState.cartItems = this.getCartItemsFromBvState(bvState.cartState.cartItems, featuresToLoad, settings.allowVisualizerSwitching, storeState.wizardState);
      if (Array.isArray(bvState.cartState.displayLogicCartItems) && bvState.cartState.displayLogicCartItems.length) {
        bvState.cartState.displayLogicCartItems = this.getCartItemsFromBvState(bvState.cartState.displayLogicCartItems, featuresToLoad, settings.allowVisualizerSwitching, storeState.wizardState)
          .filter(ci => ci.cartFeature && ci.cartFeature.dbFeature && ci.cartFeature.dbFeature.displayLogic);
      }
      if (bvState.cartState.cartItems.length) {
        store.dispatch(restoreCart(bvState.cartState));
      } else if (bvState.cartState.cameFromPage) {
        store.dispatch(setCameFromPage(bvState.cartState.cameFromPage));
      }
      if (Array.isArray(bvState.cartState.allWizardsValues) && bvState.cartState.allWizardsValues.length) {
        store.dispatch(restoreAllWizardSelectedValues(bvState.cartState.allWizardsValues)); // after cart state
      }
    }
    if (bvState.userState && (!IS_LIXIL_UI || !isLixil || bvState.userState.userInfo.email)) { // if no email passed - we don't recover anything (guest checkout issue)
      store.dispatch({
        type: types.RESTORE_USER_STATE,
        payload: bvState.userState
      });
    }
    if (bvState.installations) {
      store.dispatch({
        type: types.SET_INST_LIST,
        payload: bvState.installations
      });
    }
    if (bvState.quotes) {
      store.dispatch(setQuotes(bvState.quotes));
      store.dispatch(setActiveQuoteIndex(bvState.activeQuoteIndex || 0));
    }
    if (!bvState.useSqftCartPopup && bvState.cartState && !bvState.cartState.cartItems.some(cartItem => cartItem.sqftId)) {
      store.dispatch(changeSqftFeaturesPopup({
        enabled: false
      }));
    }
    if (((typeof bvState.contractSigningValues === "object") && Object.keys(bvState.contractSigningValues).length)
      || ((typeof bvState.contractsValues === "object") && Object.keys(bvState.contractsValues).length)) {
      store.dispatch(restoreContractValues(
        bvState.contractSigningValues,
        bvState.savedInvoiceNumberOfPages,
        bvState.needToUpdateContract,
        bvState.contractsValues,
      ));
    }
    if (bvState.receiptSignature) {
      store.dispatch(setReceiptSignature(bvState.receiptSignature));
    }
    if (bvState.receiptWorkOrderNumber || bvState.receiptHDLeadNumber || bvState.receiptBathroomLocation
      || bvState.receiptEstimateStart || bvState.receiptEstimatedText) {
      store.dispatch(setReceiptHomeDepotFields({
        receiptWorkOrderNumber: bvState.receiptWorkOrderNumber,
        receiptHDLeadNumber: bvState.receiptHDLeadNumber,
        receiptBathroomLocation: bvState.receiptBathroomLocation,
        receiptEstimateStart: bvState.receiptEstimateStart,
        receiptEstimatedText: bvState.receiptEstimatedText,
      }));
    }
    // if (bvState.useFabricatorCostPrices) { // per Alan, even if we saved with the cost price - we should see the retail prices on edit
    //   store.dispatch(toggleUseFabricatorCostPrices(true));
    // }
  }

  resetEverything() {
    this.initialized = false;
    this.type = this.defaultType;
    const features = this.getFeatures();
    const currentState = store.getState();
    const {activeQuoteIndex} = currentState.quotesState;
    features.forEach(parentGroup => {
      if (parentGroup.relatedItems && parentGroup.relatedItems.length) {
        parentGroup.relatedItems.forEach((subPart) => {
          subPart.activeFeature = null;
          subPart.placeholderChanged = false;
          subPart.firstClick[activeQuoteIndex] = false;
          subPart.disabled = subPart.defaultDisabled;
          if (Array.isArray(subPart.activeFeatureParts) && subPart.activeFeatureParts.length) {
            subPart.activeFeatureParts = subPart.setActiveFeatureParts();
          }
        });
      }
      parentGroup.activeFeature = null;
      parentGroup.placeholderChanged = false;
      if (!parentGroup.firstClick) {
        parentGroup.firstClick = {};
      }
      parentGroup.firstClick[activeQuoteIndex] = false;
      parentGroup.setDefault(this);
    });
    this.changeLayout(features);
    const bvPresets = currentState.bathroomVisualizerState.bvPresets
    const loadByTheDefault = bvPresets && bvPresets.find(preset => preset.loadByTheDefault);
    if (loadByTheDefault) {
      this.setActiveFeaturesFromObject(loadByTheDefault);
    }
    this.initialized = true;
  }

  /**
   * Returns all of the layers, based on current configuration
   * @param placeholdersNeeded {boolean}
   * @param forceReturn {boolean}
   */
  getLayers(placeholdersNeeded, forceReturn= false) {
    if (!this.initialized && !forceReturn) {
      return [];
    }

    const features = this.enabledParts(true);
    let res = [];

    // console.log('features', features);

    features.forEach(parentGroup => {
      const layers = parentGroup.setLayers(this, placeholdersNeeded);   // setLayers first! then set z-index
      // console.log('layers', layers);

      parentGroup.setZIndex(this.zIndexes[this.getCurrentLayoutName()]);  // set zIndexes

      if (layers && layers.length) {
        res = res.concat(layers);
      }
    });

    if (this.addCustomLayers) {
      res = this.addCustomLayers(res);
    }

    const {canvasDimensions} = store.getState().bathroomVisualizerState;

    const zSort = this.isNewLayout ? "desc" : "asc";

    res = orderBy(res, ['zIndex'], [zSort]).map(layer => {
      // console.log('layer', layer);
      let layerToReturn = {
        zIndex: layer.zIndex,
        image: layer.bgImg(!!layer.cropCoords),
        coords: layer.coords || null,
        partId: layer.partId || "",
        layerPosition: layer.layerPosition || "",
        cropCoords: layer.cropCoords || null,
      }
      if (this.isNewLayout && layer.zIndex < 50000) {
        const zIndexesObject = getCurrentZIndexes(this.visualizerType);
        layerToReturn.layerDimensions = zIndexesObject.getLayerDimensions(layer, this.getCurrentLayoutName(), canvasDimensions)
      }
      return layerToReturn
    });

    return res;
  }

  /**
   * Returns {array} activeFeatures objects
   */
  getActiveFeatures(returnAllFeatures, withLayerPositions = false, withDisabled = false) {
    let activeFeatures = [];
    const receiveAllFeatures = returnAllFeatures || !!(this.qtCategories && this.qtCategories.length);
    this.getFeatures(receiveAllFeatures).forEach((parentGroup) => {
      // let subParts = parentGroup.subParts().filter(subPart => !subPart.part.disabled); // we need to store every item!

      if (parentGroup.menuType === 0) { // old logic for BV visualizer
        if (!parentGroup.disabled && parentGroup.placeholderChanged && parentGroup.activeFeature) {
          activeFeatures.push({
            selectionGroup: parentGroup.partName,
            partId: parentGroup.partId,
            quantity: 0,
            cartFeature: parentGroup.activeFeature,
            featureGroup: parentGroup
          });
        }
      }

      let subItems = parentGroup.relatedItems;
      const excluded = ["fridge_shadow"];
      if (!returnAllFeatures) {
        subItems = subItems.filter(subItem => {
          if (document.kvConfig.visualizerType === "Bathroom" && subItem.partId === "shower_body" && subItem.features.length) { // shower_body should always be!
            return true
          }
          return !excluded.includes(subItem.partId) && subItem.activeFeature && subItem.activeFeature.partName
            && !subItem.activeFeature.partName.includes("laceholder")
        });
      }
      subItems.forEach((subItem) => {
        if (withLayerPositions && subItem.layerPositions) {
          Object.keys(subItem.layerPositions).forEach(position => {
            if (subItem.layerPositions[position] || withDisabled) {
              activeFeatures.push({
                selectionGroup: parentGroup.partName,
                partId: subItem.partId,
                quantity: 0,
                cartFeature: subItem.layerPositions[position] || null,
                featureGroup: subItem,
                layerPosition: position,
              });
            }
          })
        } else if (subItem.activeFeature && (withDisabled || !subItem.disabled)) {
          activeFeatures.push({
            selectionGroup: parentGroup.partName,
            partId: subItem.partId,
            quantity: 0,
            cartFeature: subItem.activeFeature || null,
            featureGroup: subItem
          });
        }
      })
    });
    // console.log('activeFeatures', activeFeatures);
    const qtCategories = this.qtCategories;
    if (!returnAllFeatures && qtCategories && qtCategories.length) {
      const subPartsObject = {};
      activeFeatures = activeFeatures.filter(activeFeature => {
        return qtCategories.some((qtCategory, qtCategoryIndex) => {
          if (!subPartsObject[qtCategoryIndex]) {
            subPartsObject[qtCategoryIndex] = qtCategory.subParts; // caching here, cause subParts requires to call getNavItems
          }
          return subPartsObject[qtCategoryIndex].some(subPart => {
            return subPart.part.partId === activeFeature.partId
          })
        })
      })
    }
    return activeFeatures
  }

  getActiveNames() {
    const allFeatures = this.getActiveFeatures(true);
    const excludedGroups = ["Background", "Globals", "Other", "Others"];
    const resultFeatures = allFeatures
      .filter(featureObject => {
        return featureObject.cartFeature && excludedGroups.every(excludedGroupName => featureObject.selectionGroup !== excludedGroupName)
      })
      .map(featureObject => {
        return {
          featureId: featureObject.cartFeature.dbFeature.id,
          parentName: featureObject.selectionGroup,
          groupName: featureObject.cartFeature.dbFeature.groupName,
          featureName: featureObject.cartFeature.getFeatureName()
        }
      })
    // console.log("resultFeatures", resultFeatures);
    return resultFeatures
  }

  /**
   *
   * @param bvState {object}
   * @param setCartAndUserState {boolean}
   * @param useNames {boolean}
   * @param needToChangeLayout {boolean}
   * @param firstLoad {boolean}
   */
  setActiveFeaturesFromObject(bvState, setCartAndUserState = false, useNames = false, needToChangeLayout = true, firstLoad = false) {
    if (bvState) {
      if (this.visualizerType === AVAILABLE_VISUALIZER_TYPES.bvScene) {
        this.restoreBvStateBathroomProperties(bvState);
      }
      const layout_type = +bvState.layout_type;
      needToChangeLayout = needToChangeLayout && (layout_type || layout_type === 0) && (layout_type !== +this.type);

      if (needToChangeLayout) {
        this.type = layout_type;
      }


      console.log("bvState===>", bvState);

      // to avoid checks below
      bvState.disabled_parts = bvState.disabled_parts || [];

      this.getFeatures()
        .forEach((parentGroup) => {
          if (parentGroup.menuType === 0) {
            const partId = parentGroup.partId;
            const hasPreviouslySavedItem = this.selectedLayoutFeatures[layout_type]
              && this.selectedLayoutFeatures[layout_type][partId];
            if (bvState.hasOwnProperty(partId) || hasPreviouslySavedItem) {
              if (useNames) {
                parentGroup.activeFeature = parentGroup.getFeatureByPartName(bvState[partId]);
                if (!parentGroup.activeFeature && hasPreviouslySavedItem) {
                  parentGroup.activeFeature = parentGroup.getFeatureByPartName(hasPreviouslySavedItem);
                }
              } else {
                parentGroup.activeFeature = parentGroup.getFeatureById(bvState[partId])
                  || parentGroup.getDefaultFeature();
              }
              parentGroup.placeholderChanged = !!parentGroup.activeFeature;
              // const {activeQuoteIndex} = store.getState().quotesState;
              // parentGroup.firstClick = !!parentGroup.activeFeature;
            }
            if (parentGroup.activeFeature && firstLoad && !parentGroup.activeFeature.notAvailableInVisualizer) { // Leave non in vis features locked
              parentGroup.activeFeature.dbFeature.unlocked = true;
            }
            if (bvState.disabled_parts.includes(partId)) {
              parentGroup.disabled = true
            }
          } else {
            let relatedItems = parentGroup.getRelatedItems();
            relatedItems.forEach((subPart) => {
              const partId = subPart.partId;
              let previouslySelectedItem = null;
              subPart.selectedFeaturesHistory.some(featureName => {
                previouslySelectedItem = subPart.getFeatureByPartName(featureName);
                return previouslySelectedItem
              });
              if (bvState.hasOwnProperty(partId) || previouslySelectedItem) {
                if (!bvState.disabled_parts.includes(partId)) {
                  subPart.disabled = false
                }
                if (useNames) {
                  const matchingFeature = subPart.getFeatureByPartName(bvState[partId]);
                  if (matchingFeature) {
                    subPart.activeFeature = matchingFeature;
                  } else if (previouslySelectedItem) {
                    subPart.activeFeature = previouslySelectedItem;
                  }
                } else {
                  subPart.activeFeature = subPart.getFeatureById(bvState[partId], true) || parentGroup.getDefaultFeature();
                }
                if (subPart.layerPositions && subPart.activeFeature) {
                  // subPart.setLayerPositions()
                  Object.keys(subPart.layerPositions).forEach(position => {
                    const partIdPosition = partId + "_" + position;
                    if (bvState[partIdPosition]) {
                      subPart.layerPositions[position] = useNames
                        ? subPart.getMatchingPositionFeature(position)
                        : subPart.getFeatureById(bvState[partIdPosition], true)
                    }
                  })
                }
                subPart.placeholderChanged = !!subPart.activeFeature;
                // const {activeQuoteIndex} = store.getState().quotesState;
                // subPart.firstClick = !!subPart.activeFeature;
                // if (subPart.firstClick) {
                //   console.log("subPart.firstClick", subPart);
                // }
              }
              if (subPart.activeFeature && firstLoad && !subPart.activeFeature.notAvailableInVisualizer) {
                subPart.activeFeature.dbFeature.unlocked = true;
                if (subPart.selectedFeaturesHistory) {
                  subPart.selectedFeaturesHistory.push(subPart.activeFeature.getMatchingFeatureName())
                }
              }
              if (bvState.disabled_parts.includes(partId)) {
                subPart.disabled = true
              }
            })
          }
        });

      if (needToChangeLayout) {
        this.changeLayout(this.getFeatures());
      }

      if (setCartAndUserState) {
        this.setCartStateAndUserStateFromBvState(bvState);
      }

      const layoutParts = this.designNavigationItems()
        .filter(parentGroup => parentGroup.part.categoryEnabled)
        .map((parentGroup) => parentGroup.part.partName);

      if (!this.isFakeLayout) {
        store.dispatch({
          type: types.SET_LAYOUT_DATA_PARTS,
          payload: {layoutParts}
        });
      }

    }
  }

  /**
   * Sets bv features from url
   */
  parseUrl(bvState) {
    if (bvState.disabled_parts) {
      bvState.disabled_parts = bvState.disabled_parts.split(",");
    }
    console.log('restoring bvState from url...', bvState);
    return bvState
  }

  /**
   *
   * @param bvState {object}
   * @param useNames {boolean}
   * @param returnAllFeatures {boolean}
   * @returns bvState {object}
   */
  addSpecificPropertiesToLocalStorage(bvState, useNames = false, returnAllFeatures = false) {
    bvState.layout_type = this.type;
    bvState.scene = this.scene;
    if (this.isNewLayout) {
      bvState.bvStateVersion = 2;
    }
    if (this.visualizerType === AVAILABLE_VISUALIZER_TYPES.bvScene || this.visualizerType === AVAILABLE_VISUALIZER_TYPES.bvLook) {
      bvState = this.addBvStateBathroomProperties(bvState);
    }
    this.getFeatures(returnAllFeatures).forEach((parentGroup) => {
      let relatedItems = parentGroup.getRelatedItems();
      relatedItems.forEach((subPart) => {
        if (subPart.layerPositions) {
          Object.keys(subPart.layerPositions).forEach(position => {
            if (subPart.layerPositions[position]) {
              bvState[subPart.partId + "_" + position] = useNames
                ? subPart.layerPositions[position].getSplittedFeatureName()
                : subPart.layerPositions[position].dbFeature.id
            }
          })
        }
        // this is used for adding these features to array of needed features form the backend on preset apply
        if (subPart.activeFeatureParts && subPart.activeFeatureParts.length) {
          subPart.activeFeatureParts.forEach((feature, featureIndex) => {
            bvState[subPart.partId + "_part_" + featureIndex] = useNames
              ? feature.getSplittedFeatureName()
              : feature.dbFeature.id
          })
        }
        if (subPart.partId === "backsplash" && subPart.getCurrentActiveFeatureType) {
          bvState["backsplash_type"] = subPart.getCurrentActiveFeatureType();
        }
      })
    })
    // console.log('bvState', bvState);
    return bvState
  }

  addBvStateBathroomProperties = (bvState) => {
    const shower = this.parts["Shower"];
    const showerTubCombo = this.parts["Shower Tub Combo"];
    bvState["shower_head_type"] = shower ? shower["shower_head_type"] : "";
    bvState["shower_hand_type"] = shower ? shower["shower_hand_type"] : "";
    const vanityParent = this.parts["Vanity"];
    bvState["vanity_type"] = vanityParent ? vanityParent["vanity_type"] : "";
    bvState.shower_tub_combo_is_active = shower.showerTubComboIsActive();
    bvState.bottom_tub = showerTubCombo.bottomTub;
    bvState.shower_floor_is_active = shower.showerFloorIsActive;
    return bvState
  }

  restoreBvStateBathroomProperties = (bvState) => {
    const shower = this.parts["Shower"];
    const showerTubCombo = this.parts["Shower Tub Combo"];

    if (shower && bvState && bvState["shower_head_type"]) {
      if (bvState["shower_head_type"] === ShowerHeadTypes.shower_arm
        && !bvState["shower_arm"] && !bvState["shower_head"] && bvState["shower_fixture"]) {
        bvState["shower_head_type"] = ShowerHeadTypes.shower_fixture; // fix for existing logic
      }
      shower.setShowerHeadType(bvState["shower_head_type"]);
    }
    if (shower && bvState && bvState["shower_hand_type"]) {
      shower.setShowerHandType(bvState["shower_hand_type"]);
    }
    const vanityParent = this.parts["Vanity"];
    vanityParent["vanity_type"] = bvState["vanity_type"]; // set it in any case! for standalone sink we are disabling vanity_type
    if (bvState["shower_tub_combo_is_active"]) {
      showerTubCombo.setShowerTubCombo();
      if (bvState.bottom_tub) {
        showerTubCombo.bottomTub = bvState.bottom_tub
      }
    } else if (showerTubCombo.showerTubComboIsActive) {
      showerTubCombo.showerTubComboIsActive = false
    }
    if (bvState["shower_floor_is_active"]) {
      shower.showerFloorIsActive = bvState["shower_floor_is_active"];
    }
  }

  getDisabledFeatures() {
    const disabledPartIds = [];
    this.getFeatures().forEach((parentGroup) => {
      if (parentGroup.menuType === 0) {
        if (parentGroup.disabled) {
          if (document.kvConfig.visualizerType === "Bathroom" && parentGroup.partName !== "Toilet") {
            disabledPartIds.push(parentGroup.partId);
          } else {
            disabledPartIds.push(parentGroup.partId);
          }
        }
      } else {
        parentGroup.relatedItems.forEach((subPart) => {
          if (subPart.disabled) {
            disabledPartIds.push(subPart.partId);
          } else if (subPart.layerPositions) {
            Object.keys(subPart.layerPositions).forEach(position => {
              if (!subPart.layerPositions[position]) {
                disabledPartIds.push(subPart.partId + "_" + position);
              }
            })
          }
        })
      }
    });
    // console.log('disabledPartIds', disabledPartIds);
    return disabledPartIds
  }

  /**
   * @param partId {string}
   * @returns featureGroup {object}
   */
  getFeatureGroupByPartId(partId) {
    if (!partId) {
      return null
    }
    let featureGroup = null;
    this.getFeatures(true).forEach(parentGroup => {
      if (featureGroup) {
        return
      }
      let relatedItems = parentGroup.relatedItems;
      relatedItems.forEach((relatedItem) => {
        if (featureGroup) {
          return
        }
        if (partId === relatedItem.partId) {
          featureGroup = relatedItem
        }
      })
    });
    return featureGroup
  }

  /**
   * @param groupName {string}
   * @returns featureGroup {object}
   */
  getFeatureGroupByGroupName(groupName) {
    if (!groupName) {
      return null
    }
    const strippedGroupName = replaceIncorrectSymbols(groupName || "").toLowerCase();
    let featureGroup = null;
    this.getFeatures(true).forEach(parentGroup => {
      if (featureGroup) {
        return
      }
      parentGroup.relatedItems.forEach((relatedItem) => {
        const strippedCurrentName = replaceIncorrectSymbols(relatedItem.dbName || relatedItem.partName || "").toLowerCase();
        if (strippedGroupName === strippedCurrentName
          || (strippedGroupName === "vanity" && strippedCurrentName === "vanitie")
          || (strippedGroupName === "corner shelf" && relatedItem.dbName === "Small Corner Shelf" && relatedItem.partName === "Corner Shelf")
          || (strippedGroupName === "shower pan"
            && ((relatedItem.dbName === "Shower Pans" && relatedItem.partName === "Shower Pan") || relatedItem.partName === "ShowerPan"))
          || (strippedGroupName === "shower pans" && relatedItem.partId === "shower_pan_combo" && document.kvConfig.visualizerType === "bvLook")
        ) {
          featureGroup = relatedItem
        }
      })
    });
    return featureGroup
  }

  /**
   * @param partId {string}
   * @param inGeneral {boolean} // this prevents asking .subParts with asks navigation items which is redundant calculations
   * @returns {boolean}
   */
  partIdExistInQtCategory(partId, inGeneral = false) {
    if ((getCurrentRoomType(this) === LOOK_ROOM_TYPES.as) && partId === "shower_door" && (this.type === 3 || this.type === 6)) {
      return false
    }
    if (inGeneral) {
      return this.qtCategoriesList && this.qtCategoriesList.some(qtCat => {
        return qtCat.defaultSubParts && qtCat.defaultSubParts.some(sPart => {
          return sPart.part && (sPart.part.partId === partId
            || (partId === "sink" && sPart.part.partId === "center_island_sink")
            || (partId === "edge_profile" && sPart.part.partId === "center_island_edge")
          )
        })
      })
    }
    return this.qtCategories && this.qtCategories.some(qtCat => {
      return qtCat.subParts && qtCat.subParts.some(sPart => sPart.part && sPart.part.partId === partId)
    })
  }

  /**
   * @param partId {string}
   * @param qtCategoryToSearch {string | null}
   * @param searchPartOfId {boolean | null}
   * @returns designNavigationItems {object}
   */
  getSubPartFromQtCategories(partId, qtCategoryToSearch = null, searchPartOfId = false) {

    const {wizardIsActive, wizardActiveItem, wizardSelectedValues} = store.getState().wizardState;
    if (wizardIsActive && wizardActiveItem) {
      const wizardSteps = getAvailableSteps(wizardActiveItem, wizardSelectedValues, true);
      return getFeatureGroupFromWizardSteps(wizardSteps, partId);
    }

    let countertopExist = null;
    let qtCategories = this.qtCategories;
    if (qtCategories) {
      if (qtCategoryToSearch) {
        qtCategories = qtCategories.filter(qtCategory => {
          return qtCategory.name.trim().toLowerCase() === qtCategoryToSearch.trim().toLowerCase()
        })
        //search in all qtCategories if wasn't found by qtCategoryToSearch
        if (qtCategories.length === 0) {
          qtCategories = this.qtCategories
        }
      }
      qtCategories.forEach(qtCategory => {
        if (!countertopExist) {
          const subParts = qtCategory.subParts;
          let neededSubPart;
          if (searchPartOfId) {
            neededSubPart = subParts.find(subPart => subPart.part.partId.includes(partId));
          } else {
            neededSubPart = subParts.find(subPart => subPart.part.partId === partId);
          }
          if (neededSubPart) {
            countertopExist = neededSubPart;
          }
        }
      });
    }
    return countertopExist
  }

}
